var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-6 pl-lg-4 pl-md-0"},[_c('h2',{staticClass:"font-weight-bold mb-4"},[_vm._v("Follow on Twitter")]),_c('twitter-post')],1)}
var staticRenderFns = []

export { render, staticRenderFns }